import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { recurringDaysAvailable } from "./RegisterLessonModal";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

interface recurringDaysInterface {
    label: string
    value: number
}
function RecurringEvent({
  recurringDays,
  setRecurringDays,
  setRecurringEndDate,
  mode
}: {
  recurringDays: number[];
  setRecurringDays: Dispatch<SetStateAction<number[]>>;
  setRecurringEndDate: Dispatch<SetStateAction<string>>;
  mode: "Game" | "Lesson"
}) {
  const [recurringEvent, setRecurringEvent] = useState(false);

  function updateRecurringDays(listDays: recurringDaysInterface[]) {
    const newDays = listDays.map((day) => {
      return day.value;
    });
    setRecurringDays(newDays);
  }
  return (
    <Stack spacing={2}>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={recurringEvent}
              onChange={(event) => setRecurringEvent(!recurringEvent)}
            />
          }
          label={"Recurring " + mode}
        />
      </FormGroup>
      <Autocomplete
        multiple
        id="recurring-days"
        options={recurringDaysAvailable}
        //getOptionLabel={(option) => option.title}
        disabled={!recurringEvent}
        //defaultValue={recurringDays}
        getOptionDisabled={(option: any) =>
          recurringDays.includes(option.value)
        }
        //isOptionEqualToValue={(option, value) => option.value === value}
        onChange={(event, newValue) => updateRecurringDays(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Recur Every"
            placeholder="Day"
          />
        )}
      />
      <DatePicker
        label="Stop On"
        onChange={(event: any) => {
          setRecurringEndDate(moment(event["$d"]).format("YYYY-MM-DD"));
        }}
        disabled={!recurringEvent}
      />
    </Stack>
  );
}

export default RecurringEvent;
